import { keyframes } from '@grupoboticario/flora'

export const baseAnimation = '200ms cubic-bezier(0.22, 1, 0.36, 1)'

export const fadeIn = keyframes({
  from: { opacity: '0' },
  to: { opacity: '1' },
})

export const fadeOut = keyframes({
  from: { opacity: '1' },
  to: { opacity: '0' },
})

export const slideDown = keyframes({
  '0%': { opacity: 0, transform: 'translateY(-10px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
})

export const slideUp = keyframes({
  '0%': { opacity: 0, transform: 'translateY(10px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
})

export const slideIn = keyframes({
  from: { transform: 'translate3d(0,90px,0)', opacity: 0 },
  to: { transform: 'translate3d(0,0,0)', opacity: 1 },
})

export const slideOut = keyframes({
  from: { transform: 'translate3d(0,0,0)', opacity: 1 },
  to: { transform: 'translate3d(0,90px,0)', opacity: 0 },
})

export const slideDownIn = keyframes({
  from: { transform: 'translate3d(0, -100px,0)', opacity: 0 },
  to: { transform: 'translate3d(0, 0,0)', opacity: 1 },
})

export const slideDownOut = keyframes({
  from: { transform: 'translate3d(0,0,0)', opacity: 1 },
  to: { transform: 'translate3d(0,100px,0)', opacity: 0 },
})

export const scaleIn = keyframes({
  from: { transform: 'scale(0.8)', opacity: 0 },
  to: { transform: 'scale(1)', opacity: 1 },
})

export const scaleOut = keyframes({
  from: { transform: 'scale(1)', opacity: 1 },
  to: { transform: 'scale(0.8)', opacity: 0 },
})
